<template>
  <div class="visual-content">
    <VisualContent
      @showVisualForm="doShowVisualForm"
      @showVisualDetail="doShowVisualDetail"
      @dropPic="doDropPic"
      @dataLoaded="onMomentLoaded"
      :images="filesImage"
      ref="visualContent"
    />
    <transition name="fade">
      <VisualForm
        @showVisualForm="doShowVisualForm"
        v-if="showVisualForm"
        @removeImage="doRemoveImage"
        @updated="onVisualFormUpdated"
        ref="visualForm"
      />
    </transition>
    <transition name="fade">
      <VisualDetail
        v-if="showVisualDetail"
        :images="items"
        :index="indexPic"
        @closeDetail="closeVisualDetail"
        @goPrevious="onGoPrevious"
        @goNext="onGoNext"
      />
    </transition>
  </div>
</template>

<script>
import VisualContent from "./VisualContent";
import VisualForm from "./VisualForm";
import VisualDetail from "./VisualDetail";
export default {
  components: {
    VisualContent,
    VisualForm,
    VisualDetail,
  },
  data() {
    return {
      showVisualForm: false,
      showVisualDetail: false,
      filesImage: [],
      indexPic: 0,
      totalPosts: 0,
      items: [],
    };
  },
  methods: {
    doShowVisualForm() {
      this.showVisualForm = !this.showVisualForm;
      if (this.showVisualForm) {
        document.getElementsByTagName("html")[0].style.overflow = "hidden";
        document.getElementsByTagName("html")[0].style.paddingRight = "15px";
      } else {
        document.getElementsByTagName("html")[0].style.overflow = "";
        document.getElementsByTagName("html")[0].style.paddingRight = "";
      }

      if (this.showVisualForm == false) {
        this.filesImage = [];
      }
    },
    doShowVisualDetail(items, index) {
      this.items = items;
      this.indexPic = index < -1 ? this.items.length : index;
      this.showVisualDetail = !this.showVisualDetail;
      if (this.showVisualDetail) {
        document.getElementsByTagName("html")[0].style.overflow = "hidden";
        document.getElementsByTagName("html")[0].style.paddingRight = "15px";
      } else {
        document.getElementsByTagName("html")[0].style.overflow = "";
        document.getElementsByTagName("html")[0].style.paddingRight = "";
      }

      if (this.showVisualDetail == false) {
        this.items = [];
        this.indexPic = 0;
      }
    },
    closeVisualDetail() {
      this.showVisualDetail = false;
      if (this.showVisualDetail) {
        document.getElementsByTagName("html")[0].style.overflow = "hidden";
        document.getElementsByTagName("html")[0].style.paddingRight = "15px";
      } else {
        document.getElementsByTagName("html")[0].style.overflow = "";
        document.getElementsByTagName("html")[0].style.paddingRight = "";
      }

      if (this.showVisualDetail == false) {
        this.items = [];
        this.indexPic = 0;
      }
    },
    doDropPic(value) {
      this.doShowVisualForm();
      setTimeout(() => {
        this.$refs.visualForm.uploadFile(value);
      }, 100);
    },
    doRemoveImage() {
      this.filesImage = [];
    },
    async onVisualFormUpdated() {
      await this.$refs.visualContent.load();
    },
    onMomentLoaded(data) {
      this.totalPosts = data.totalPosts;
    },
    onGoPrevious() {
      if (this.indexPic > 0) {
        this.indexPic--;
      }
    },
    onGoNext() {
      if (this.indexPic < this.totalPosts - 1) {
        this.indexPic++;
      }
    },
  },
};
</script>

<style lang="scss">
.visual-content {
  padding-bottom: 50px;
  .title {
    color: (--color-gray);
    font-size: 24px;
    font-weight: bold;
  }

  button {
    border-radius: 4px;

    &.btn-add-content {
      background-color: (--color-gray);
      border-radius: 0;
      color: #fff;
      text-transform: uppercase;
      font-weight: 500;
    }

    &.btn-filter {
      background-color: #6c757d;
      border-radius: 25px;
      color: #fff;
      font-size: 12px;
      text-transform: none;

      &.active {
        background-color: 707070;
      }
    }
  }

  .list-images-container ul {
    list-style: none;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-auto-rows: 1fr;
    column-gap: 2px;
    row-gap: 2px;

    &.list-images {
      li {
        position: relative;
        height: 0;
        padding-bottom: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-color: rgba(0, 0, 0, 0.5);

        &:after {
          content: "";
          display: block;
          padding-bottom: 100%;
        }

        .content {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 50%;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          padding: 10px;

          &.reject {
            background-image: linear-gradient(transparent, #c53f3f);
          }

          &.approved {
            background-image: linear-gradient(
              transparent,
              var(--primary-color)
            );
          }

          &.pending {
            background-image: linear-gradient(transparent, #58595b);
          }
        }
      }
    }

    &.list-hashtag {
      display: flex;
      flex-wrap: wrap;
      padding: 0;
      margin-left: -3px;
      margin-right: -3px;
      li {
        margin: 3px;
        width: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 10px;
        font-size: 12px;
        background-color: #b9b9b9;
        color: #fff;
        border-radius: 25px;
      }
    }
  }

  .btn-reset {
    margin-left: 5px;
    font-size: 12px;
    color: #b9b9b9;
    text-decoration: underline;
  }

  .drag-drop {
    display: flex;
    justify-content: center;
    align-items: center;
    border: var(--color-gray) 2px solid;
    color: var(--color-gray);
    font-size: 14px;
    padding: 22px 26px;
    i {
      font-size: 30px;
    }
  }

  .card-title {
    font-size: 18px;
    color: 707070;
  }

  .form-check-label {
    font-size: 12px;
  }

  input {
    &.form-control {
      border-radius: 0;
    }

    &.form-control-plaintext {
      border: 0;
    }
  }

  select {
    &.form-control {
      border-radius: 0;
      background-image: url("../../assets/images/select-style.jpg");
      background-repeat: no-repeat, repeat;
      background-position: right 0 top 50%, 0 0;
      padding-right: 39px;
    }
  }

  .drag-hover:hover {
    background-color: #eee;
  }

  @media only screen and (max-width: 1500px) {
    .sizefont-12 {
      font-size: 11px;
    }
  }
  @media screen and (max-width: $breakpoint-tablet) {
    .list-images-container ul {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
